export default "__VITE_ASSET__Vvo9O96D__"